import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteConstants } from "../route/services/RouteConstants";
import { getLanguage, getFeatureFlags } from "../../store/rootReducer";
import HrbTranslate from '../language/HrbTranslate';
import checkmarkIcon from '../../assets/images/checkmark-icon.svg';
import exclamationIcon from '../../assets/images/exclamation-icon.svg';
import externalApps from '../../services/externalApps/ExternalApps';
import './UpdateEmailComplete.scss';

class UpdateEmailComplete extends Component {

  constructor(props) {
    super(props);
    this.state = {
      newEmail: '',
      emailExists: false
    };
  }

  componentDidMount() {
    const locationState = this.props.location.state;
    if (!locationState || (!locationState.newEmail && !locationState.email)) {
      this.props.history.push(RouteConstants.UPDATE_EMAIL);
    } else {
      this.setState({ 
        newEmail: locationState.newEmail || locationState.email,
        emailExists: locationState.emailExists || false
      });
      this._successPageUrl = window.location.href;
      window.history.pushState(null, '', this._successPageUrl);
      window.addEventListener('popstate', this.handlePopState, true);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState, true);
  }

  handlePopState = () => {
    window.history.pushState(null, '', this._successPageUrl);
  };

  getCurrentTaxYear = () => {
    const currentYear = this.props.featureFlags?.use_season_readiness_current_tax_year;
    return currentYear ? Math.floor(currentYear) : new Date().getFullYear();
  };

  handleGoToTaxSoftware = () => {
    const currentTaxYear = this.getCurrentTaxYear();
    const diyAppName = `DIY${currentTaxYear.toString().slice(-2)}`;
    const appInfo = externalApps.getAppInfo(diyAppName);
    
    if (appInfo && appInfo.baseUrl) {
      window.location.href = appInfo.baseUrl;
    }
  };

  handleGoToRemoteTaxExpert = () => {
    const appInfo = externalApps.getAppInfo('RTE');
    
    if (appInfo && appInfo.baseUrl) {
      window.location.href = appInfo.baseUrl;
    }
  };

  render() {
    const { emailExists } = this.state;
    const titleKey = emailExists ? 'update_email.email_exists.title' : 'update_email.complete.title';
    const messageKey = emailExists ? 'update_email.email_exists.message' : 'update_email.complete.message';
    const icon = emailExists ? exclamationIcon : checkmarkIcon;
    
    return (
      <div className="hrb-update-email-complete-card">
        <div className="hrb-update-email-complete-icon">
          <img src={icon} alt="" />
        </div>
        <h1 className="hrb-update-email-complete-title">
          <HrbTranslate text={titleKey} />
        </h1>
        <p className="hrb-update-email-complete-message">
          <HrbTranslate text={messageKey} />
        </p>
        <div className="hrb-update-email-complete-buttons">
          <button 
            className="hrb-update-email-complete-button secondary"
            onClick={this.handleGoToTaxSoftware}
          >
            <HrbTranslate text="update_email.complete.go_to_tax_software" />
          </button>
          <button 
            className="hrb-update-email-complete-button secondary"
            onClick={this.handleGoToRemoteTaxExpert}
          >
            <HrbTranslate text="update_email.complete.go_to_remote_tax_expert" />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state),
    featureFlags: getFeatureFlags(state)
  };
};

export default connect(mapStateToProps)(UpdateEmailComplete);
